<div class="layout-topbar">
  <a class="app-logo" routerLink="/">
    @if (railMark; as mark) {
      <div class="app-logo-tile" [class.has-background]="railMarkHasBackground"><img [src]="mark" alt="app logo" /></div>
    } @else {
      <div [ngClass]="'box-logo-production'">
        <img [ngClass]="'logo-production'" alt="app logo" [src]="displayLogo" />
      </div>
    }
  </a>

  <button #menubutton class="topbar-menubutton p-link" type="button" (click)="onMenuButtonClick()">
    <span></span>
  </button>

  <app-sign-in-as-banner class="mr-4" />

  <div class="topbar-profile">
    <button
      #userMenuTrigger
      class="topbar-profile-button p-link"
      type="button"
      aria-haspopup="dialog"
      [attr.aria-expanded]="userMenuOpen"
      aria-label="User menu"
      (click)="userMenu.toggle($event)">
      @if (getUserDetail(); as userDetail) {
        <span class="user-avatar">
          <span>{{ userDetail.firstInitial }}</span>
          <span>{{ userDetail.lastInitial }}</span>
        </span>
      }

      <span class="flex flex-col">
        <span class="text-white font-bold">{{ userInfo }}</span>
        <span class="text-white">{{ userRole }}</span>
      </span>
      <span class="text-white">
        <i class="pi pi-angle-down"></i>
      </span>
    </button>
    <!-- The user menu: identity, the person's own preferences, Sign out. Esc and a click outside close it. -->
    <p-popover
      #userMenu
      (onShow)="userMenuOpen = true; userMenuPanel.focusFirstControl()"
      (onHide)="userMenuOpen = false; userMenuPanel.returnFocus(userMenuTrigger)">
      <app-user-menu #userMenuPanel (closed)="userMenu.hide()" />
    </p-popover>
  </div>
</div>
